let id = 0;

const uniqueId = () => {
    return 'id-' + id++;
};

export default uniqueId;
